const NOISY_USER_AGENT_RE = /bot|crawler|spider|headless|lighthouse|pagespeed|prerender/i;
const EXTENSION_FILE_RE = /^(chrome|moz|safari|webkit)-extension:\/\//i;
const THIRD_PARTY_FILE_RE =
  /googletagmanager|google-analytics|analytics\.tiktok|connect\.facebook|emarsys|scarab|criteo|creativecdn|bat\.bing|awswaf|cookiepro|recaptcha/i;
const NOISY_MESSAGE_RE =
  /metamask|runtime\.sendmessage|script error|loading chunk|failed to fetch dynamically imported module|resizeobserver loop/i;

/**
 * 判断自动错误采集是否应该保留当前错误。
 * @param error - 浏览器 ErrorEvent 或普通 Event
 * @returns true 表示采集，false 表示过滤
 */
export function shouldTrackSnowplowError(error: ErrorEvent | Event): boolean {
  try {
    const userAgent = navigator.userAgent || '';
    const filename = error instanceof ErrorEvent ? error.filename || '' : '';
    const message = error instanceof ErrorEvent ? error.message || '' : '';

    if (NOISY_USER_AGENT_RE.test(userAgent)) return false;
    if (EXTENSION_FILE_RE.test(filename)) return false;
    if (THIRD_PARTY_FILE_RE.test(filename)) return false;
    if (NOISY_MESSAGE_RE.test(message)) return false;

    return true;
  } catch {
    return false;
  }
}
